import React, { useState } from 'react';
import './login.css';
import { Backdrop, Button, CircularProgress } from '@mui/material';
import { toast } from 'react-toastify';
import { endpoint } from '../../../resource/Constant';
import { useNavigate } from 'react-router';
import axios from 'axios';

export default function ChatVerifyOtp() {
  const [otpObj, setOtpObj] = useState({ support: undefined, otp: undefined });
  const [loading, setLoading] = useState(false);
  const [resendOtp, setResendOtp] = useState(false);
  const navigate = useNavigate();

  const onVerifyOtp = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(endpoint + `/api/aichatbot/verify-otp`, null, { params: { support: otpObj.support, otp: otpObj.otp } })
      .then((res) => {
        toast.success(`Account Acctivated!`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
        navigate('/aichatbot/login');
      })
      .catch((e) => {
        toast.error(`Invalid OTP!`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };
  const onResendOtp = (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(endpoint + `/api/aichatbot/resendotp`, { support: otpObj.support })
      .then((res) => {
        setResendOtp(false);
        toast.success(`OTP Sent!`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      })
      .catch((e) => {
        toast.error(`${e.response.data.message}`, {
          position: toast.POSITION.TOP_RIGHT,
          toastId: 'error1'
        });
        setLoading(false);
      });
  };
  return (
    <div
      style={{
        height: '100vh', // full screen height
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: "'Roboto', sans-serif"
      }}
    >
      <div className="signup-form">
        {!resendOtp ? (
          <>
            <form onSubmit={onVerifyOtp}>
              <h2 style={{ color: '#008267', marginBottom: '20px' }}>Verify Otp</h2>
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="email"
                  placeholder="Email"
                  required
                  className="form-control"
                  value={otpObj.support}
                  onChange={(e) => {
                    setOtpObj((prev) => ({ support: e.target.value, otp: prev.otp }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputFullName"
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="number"
                  placeholder="OTP"
                  required
                  className="form-control"
                  value={otpObj.otp}
                  onChange={(e) => {
                    setOtpObj((prev) => ({ support: prev.support, otp: e.target.value }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputFullName"
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    border: 'none',
                    color: '#fff',
                    padding: '10px 20px',
                    fontSize: '16px',
                    width: '100%',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = 'rgb(45 82 126)')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = 'rgb(65 90 119)')}
                >
                  Verify
                </button>
              </div>
            </form>
            <div>
              <p style={{ fontSize: '14px' }}>
                {/* Resend otp?{" "} */}
                <Button
                  //   href="/login"
                  onClick={() => {
                    setResendOtp(true);
                  }}
                  style={{
                    color: '#007e94',
                    textDecoration: 'none'
                  }}
                >
                  Resend Otp
                </Button>
              </p>
            </div>
          </>
        ) : (
          <>
            <form onSubmit={onResendOtp}>
              <h2 style={{ color: '#008267', marginBottom: '20px' }}>Resend Otp</h2>
              <div style={{ marginBottom: '20px' }}>
                <input
                  type="email"
                  placeholder="Email"
                  required
                  className="form-control"
                  value={otpObj.support}
                  onChange={(e) => {
                    setOtpObj((prev) => ({ support: e.target.value, otp: prev.otp }));
                  }}
                  style={{
                    height: '50px',
                    width: '100%',
                    padding: '10px',
                    borderRadius: '5px',
                    border: '1px solid #ddd',
                    marginBottom: '10px',
                    fontSize: '16px'
                  }}
                  id="exampleInputFullName"
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundImage: 'var(--rg-shadow-gradient-teal, linear-gradient(123deg, #008559 0%, #007e94 50%, #006ce0 100%))',
                    border: 'none',
                    color: '#fff',
                    padding: '10px 20px',
                    fontSize: '16px',
                    width: '100%',
                    borderRadius: '5px',
                    cursor: 'pointer',
                    transition: 'background-color 0.3s'
                  }}
                  onMouseOver={(e) => (e.target.style.backgroundColor = 'rgb(45 82 126)')}
                  onMouseOut={(e) => (e.target.style.backgroundColor = 'rgb(65 90 119)')}
                >
                  Send
                </button>
              </div>
            </form>
            <div>
              <p style={{ fontSize: '14px' }}>
                {/* Resend otp?{" "} */}
                <Button
                  //   href="/login"
                  onClick={() => {
                    setResendOtp(false);
                  }}
                  style={{
                    color: '#007e94',
                    textDecoration: 'none'
                  }}
                >
                  Verify Otp
                </Button>
              </p>
            </div>
          </>
        )}
      </div>
      <Backdrop open={loading}>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress sx={{ 'svg circle': { stroke: 'url(#my_gradient)' } }} size={70} thickness={3} />
      </Backdrop>
    </div>
  );
}
